export default __webpack_public_path__ + "static/media/boite10.3f76d8ef.jpg";